import React, { useState } from "react";
import "./ShoppingCart.css";
import { useSelector, useDispatch } from "react-redux";
import {
  removeFromCart,
  updateQuantity,
  selectCartTotalAmount,
} from "../../Features/Cart/cartSlice";
import { MdOutlineClose } from "react-icons/md";
import { Link } from "react-router-dom";
import success from "../../Assets/success.png";
import * as backendModule from "../../modules/backendModule";
import axios from "axios";
import Spinner from "../Spinner";

const ShoppingCart = () => {
  const cartItems = useSelector((state) => state.cart.items);
  const dispatch = useDispatch();

  const shippingPrice = cartItems.length > 0 ? 12 : 0;

  const [activeTab, setActiveTab] = useState("cartTab1");
  const [payments, setPayments] = useState(false);
  const [orderID, setOrderID] = React.useState(null);
  const [spinner, setSpinner] = React.useState(false);
  const [error, setError] = React.useState(null);
  const [message, setMessage] = React.useState(null);
  const [country, setCountry] = React.useState(null);
  const [selectedPayment, setSelectedPayment] = useState(null);

  const firstNameRef = React.useRef(null);
  const lastNameRef = React.useRef(null);
  const streetRef = React.useRef(null);
  const cityRef = React.useRef(null);
  const postcodeRef = React.useRef(null);
  const phoneRef = React.useRef(null);
  const notesRef = React.useRef(null);

  const handleTabClick = (tab) => {
    if (tab === "cartTab1" || cartItems.length > 0) {
      setActiveTab(tab);
    }
  };

  const handleQuantityChange = (productId, quantity) => {
    if (quantity >= 1 && quantity <= 20) {
      dispatch(updateQuantity({ productID: productId, quantity: quantity }));
    }
  };

  const totalPrice = useSelector(selectCartTotalAmount);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // current Date

  const currentDate = new Date();

  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const createOrder = () => {
    let productsInfo = [];
    cartItems.map(item => {
      productsInfo.push({ ProductID: item.ID, Quantity: item.quantity, ProductName: item.Name, Brand: item.Brand, ImagePath: item.ImagePath });
    });

    if (
      firstNameRef.current.value &&
      lastNameRef.current.value &&
      country &&
      streetRef.current.value &&
      cityRef.current.value &&
      postcodeRef.current.value &&
      phoneRef.current.value &&
      selectedPayment
    ) {
      setSpinner(true);
    } else {
      setError('Niste popunili sve tražene podatke');
      return;
    }

    const orderData = {
      FirstName: firstNameRef.current.value,
      LastName: lastNameRef.current.value,
      Country: country,
      Street: streetRef.current.value,
      City: cityRef.current.value,
      Postcode: postcodeRef.current.value,
      Phone: phoneRef.current.value,
      Notes: notesRef.current.value,
      PaymentMethod: selectedPayment,
      Products: productsInfo,
      TotalPrice: totalPrice,
      ShippingPrice: shippingPrice,
      Status: 0
    };

    if (selectedPayment === "Card") {
      axios({
        method: "POST",
        url: `${backendModule.backendURL}/orders/monri/create`,
        data: orderData,
        ...backendModule.axiosConfig,
      }).then(res => {
        if (res.data.status !== "ok") throw new Error("MONRI_CREATE_FAILED");
        const form = document.createElement("form");
        form.method = "POST";
        form.action = res.data.data.action;
        Object.entries(res.data.data.fields).forEach(([name, value]) => {
          const input = document.createElement("input");
          input.type = "hidden";
          input.name = name;
          input.value = value;
          form.appendChild(input);
        });
        document.body.appendChild(form);
        form.submit();
      }).catch(() => {
        setError("Nije moguće pokrenuti kartično plaćanje. Pokušajte ponovo.");
        setSpinner(false);
      });
      return;
    }

    axios({
      method: "POST",
      url: `${backendModule.backendURL}/orders/addOrder`,
      data: orderData,
      ...backendModule.axiosConfig,
    }).then(res => {
      if (res.data.status === "ok") {
        setOrderID(res.data?.data);
        setMessage('Hvala vam! Vaša narudžba je zaprimljena.');
        setError(null);
      } else {
        setError('Dogodila se serverska greška...');
        setMessage(null);
      }
    }).catch(() => {
      setError('Dogodila se serverska greška...');
      setMessage(null);
    }).finally(() => {
      handleTabClick("cartTab3");
      window.scrollTo({ top: 0, behavior: "smooth" });
      setPayments(true);
      setSpinner(false);
    });
  }

  const handlePaymentChange = (e) => {
    setSelectedPayment(e.target.value);
  };

  return (
    <>
      <div className="shoppingCartSection">
        <h2>Korpa</h2>

        <div className="shoppingCartTabsContainer">
          <div className={`shoppingCartTabs ${activeTab}`}>
            <button
              className={activeTab === "cartTab1" ? "active" : ""}
              onClick={() => {
                handleTabClick("cartTab1");
                setPayments(false);
              }}
            >
              <div className="shoppingCartTabsNumber">
                <h3>01</h3>
                <div className="shoppingCartTabsHeading">
                  <h3>Korpa</h3>
                  <p>Upravljaj svojim artiklima</p>
                </div>
              </div>
            </button>
            <button
              className={activeTab === "cartTab2" ? "active" : ""}
              onClick={() => {
                handleTabClick("cartTab2");
                setPayments(false);
              }}
              disabled={cartItems.length === 0}
            >
              <div className="shoppingCartTabsNumber">
                <h3>02</h3>
                <div className="shoppingCartTabsHeading">
                  <h3>Dostava i plaćanje</h3>
                  <p>Plati svoje artikle</p>
                </div>
              </div>
            </button>
            <button
              className={activeTab === "cartTab3" ? "active" : ""}
              onClick={() => {
                handleTabClick("cartTab3");
              }}
              disabled={cartItems.length === 0 || payments === false}
            >
              <div className="shoppingCartTabsNumber">
                <h3>03</h3>
                <div className="shoppingCartTabsHeading">
                  <h3>Potvrda</h3>
                  <p>Pregledaj i potvrdi svoju narudžbu</p>
                </div>
              </div>
            </button>
          </div>
          <div className="shoppingCartTabsContent">
            {/* tab1 */}
            {activeTab === "cartTab1" && (
              <div className="shoppingBagSection">
                <div className="shoppingBagTableSection">
                  {/* For Desktop Devices */}
                  <table className="shoppingBagTable">
                    <thead>
                      <tr>
                        <th>Proizvod</th>
                        <th></th>
                        <th>Cijena</th>
                        <th>Količina</th>
                        <th>Ukupno</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {cartItems.length > 0 ? (
                        cartItems.map((item) => (
                          <tr key={item.ID}>
                            <td data-label="Product">
                              <div className="shoppingBagTableImg">
                                <Link to="/product" onClick={scrollToTop}>
                                  <img src={`${backendModule.backendURL}/${item.ImagePath}`} alt="" />
                                </Link>
                              </div>
                            </td>
                            <td data-label="">
                              <div className="shoppingBagTableProductDetail">
                                <Link to="/product" onClick={scrollToTop}>
                                  <h4>{item.Name}</h4>
                                </Link>
                                <p>{item.productReviews}</p>
                              </div>
                            </td>
                            <td
                              data-label="Price"
                              style={{ textAlign: "center" }}
                            >
                              {item.Price} KM
                            </td>
                            <td data-label="Quantity">
                              <div className="ShoppingBagTableQuantity">
                                <button
                                  onClick={() =>
                                    handleQuantityChange(
                                      item.productID,
                                      item.quantity - 1
                                    )
                                  }
                                >
                                  -
                                </button>
                                <input
                                  type="text"
                                  min="1"
                                  max="20"
                                  value={item.quantity}
                                  onChange={(e) =>
                                    handleQuantityChange(
                                      item.productID,
                                      parseInt(e.target.value)
                                    )
                                  }
                                />
                                <button
                                  onClick={() =>
                                    handleQuantityChange(
                                      item.productID,
                                      item.quantity + 1
                                    )
                                  }
                                >
                                  +
                                </button>
                              </div>
                            </td>
                            <td data-label="Subtotal">
                              <p
                                style={{
                                  textAlign: "center",
                                  fontWeight: "500",
                                }}
                              >
                                {item.quantity * item.Price} KM
                              </p>
                            </td>
                            <td data-label="">
                              <MdOutlineClose
                                onClick={() =>
                                  dispatch(removeFromCart(item.productID))
                                }
                              />
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="6">
                            <div className="shoppingCartEmpty">
                              <span>Vaša korpa je prazna!</span>
                              <Link to="/shop" onClick={scrollToTop}>
                                <button>Započni kupovinu</button>
                              </Link>
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                    <tfoot>
                      <th
                        colSpan="6"
                        className="shopCartFooter"
                        style={{
                          borderBottom: "none",
                          padding: "20px 0px",
                        }}
                      >
                        {/*cartItems.length > 0 && (
                          <div className="shopCartFooterContainer">
                            <form>
                              <input
                                type="text"
                                placeholder="Coupon Code"
                              ></input>
                              <button
                                onClick={(e) => {
                                  e.preventDefault();
                                }}
                              >
                                Apply Coupon
                              </button>
                            </form>
                            <button
                              onClick={(e) => {
                                e.preventDefault();
                              }}
                              className="shopCartFooterbutton"
                            >
                              Update Cart
                            </button>
                          </div>
                        )*/}
                      </th>
                    </tfoot>
                  </table>

                  {/* For Mobile devices */}

                  <div className="shoppingBagTableMobile">
                    {cartItems.length > 0 ? (
                      <>
                        {cartItems.map((item) => (
                          <div key={item.ID}>
                            <div className="shoppingBagTableMobileItems">
                              <div className="shoppingBagTableMobileItemsImg">
                                <Link to="/product" onClick={scrollToTop}>
                                  <img src={`${backendModule.backendURL}/${item.ImagePath}`} alt="" />
                                </Link>
                              </div>
                              <div className="shoppingBagTableMobileItemsDetail">
                                <div className="shoppingBagTableMobileItemsDetailMain">
                                  <Link to="/product" onClick={scrollToTop}>
                                    <h4>{item.Name}</h4>
                                  </Link>
                                  <div className="shoppingBagTableMobileQuantity">
                                    <button
                                      onClick={() =>
                                        handleQuantityChange(
                                          item.productID,
                                          item.quantity - 1
                                        )
                                      }
                                    >
                                      -
                                    </button>
                                    <input
                                      type="text"
                                      min="1"
                                      max="20"
                                      value={item.quantity}
                                      onChange={(e) =>
                                        handleQuantityChange(
                                          item.productID,
                                          parseInt(e.target.value)
                                        )
                                      }
                                    />
                                    <button
                                      onClick={() =>
                                        handleQuantityChange(
                                          item.productID,
                                          item.quantity + 1
                                        )
                                      }
                                    >
                                      +
                                    </button>
                                  </div>
                                  <span>{item.Price} KM</span>
                                </div>
                                <div className="shoppingBagTableMobileItemsDetailTotal">
                                  <MdOutlineClose
                                    size={20}
                                    onClick={() =>
                                      dispatch(removeFromCart(item.ID))
                                    }
                                  />
                                  <p>{item.quantity * item.Price} KM</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                        {/*<div className="shopCartFooter">
                          <div className="shopCartFooterContainer">
                            <form>
                              <input
                                type="text"
                                placeholder="Coupon Code"
                              ></input>
                              <button
                                onClick={(e) => {
                                  e.preventDefault();
                                }}
                              >
                                Apply Coupon
                              </button>
                            </form>
                            <button
                              onClick={(e) => {
                                e.preventDefault();
                              }}
                              className="shopCartFooterbutton"
                            >
                              Update Cart
                            </button>
                          </div>
                        </div>*/}
                      </>
                    ) : (
                      <div className="shoppingCartEmpty">
                        <span>Vaša korpa je prazna!</span>
                        <Link to="/shop" onClick={scrollToTop}>
                          <button>Započni kupovinu</button>
                        </Link>
                      </div>
                    )}
                  </div>
                </div>
                <div className="shoppingBagTotal">
                  <h3>Proračun</h3>
                  <table className="shoppingBagTotalTable">
                    <tbody>
                      <tr>
                        <th>Vrijednost</th>
                        <td>{totalPrice.toFixed(2)} KM</td>
                      </tr>
                      <tr>
                        <th>Dostava</th>
                        <td>
                          <div className="shoppingBagTotalTableCheck">
                            <p>{shippingPrice.toFixed(2)} KM</p>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th>Ukupno</th>
                        <td>
                          {totalPrice === 0 ? 0 : (Number(totalPrice) + Number(shippingPrice)).toFixed(2)} KM
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <button
                    onClick={() => {
                      handleTabClick("cartTab2");
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                    disabled={cartItems.length === 0}
                  >
                    Idi na plaćanje
                  </button>
                </div>
              </div>
            )}

            {/* tab2 */}
            {activeTab === "cartTab2" && (
              <div className="checkoutSection">
                <div className="checkoutDetailsSection">
                  <h4>Podaci za dostavu</h4>
                  <div className="checkoutDetailsForm">
                    <form>
                      <div className="checkoutDetailsFormRow">
                        <input type="text" placeholder="Ime" ref={firstNameRef} />
                        <input type="text" placeholder="Prezime" ref={lastNameRef} />
                      </div>
                      <select
                        name="country"
                        id="country"
                        value={country}
                        onChange={(e) => setCountry(e.target.value)}
                      >
                        <option value="Country / Region" selected disabled>
                          Country
                        </option>
                        <option value="Bosna i Hercegovina">Bosna i Hercegovina</option>
                        <option value="Hrvatska">Hrvatska</option>
                        <option value="Srbija">Srbija</option>
                        <option value="Njemačka">Njemačka</option>
                        <option value="Austrija">Austrija</option>
                        <option value="Slovenija">Slovenija</option>
                        <option value="Švicarska">Švicarska</option>
                      </select>
                      <input type="text" placeholder="Ulica*" ref={streetRef} />
                      <input type="text" placeholder="Grad*" ref={cityRef} />
                      <input type="text" placeholder="Poštanski broj*" ref={postcodeRef} />
                      <input type="text" placeholder="Telefon*" ref={phoneRef} />
                      <textarea
                        cols={30}
                        rows={8}
                        placeholder="Napomena (Opcionalno)"
                        ref={notesRef}
                      />
                    </form>
                  </div>
                </div>
                <div className="checkoutPaymentSection">
                  <div className="checkoutTotalContainer">
                    <h3>Vaša narudžba</h3>
                    <div className="checkoutItems">
                      <table>
                        <thead>
                          <tr>
                            <th>PROIZVODI</th>
                            <th>VRIJEDNOST</th>
                          </tr>
                        </thead>
                        <tbody>
                          {cartItems.map((items) => (
                            <tr>
                              <td>
                                {items.Name} x {items.quantity}
                              </td>
                              <td>{items.Price * items.quantity} KM</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    <div className="checkoutTotal">
                      <table>
                        <tbody>
                          <tr>
                            <th>VRIJEDNOST</th>
                            <td>{totalPrice.toFixed(2)} KM</td>
                          </tr>
                          <tr>
                            <th>DOSTAVA</th>
                            <td>{shippingPrice.toFixed(2)} KM</td>
                          </tr>
                          <tr>
                            <th>UKUPNO</th>
                            <td>

                              {totalPrice === 0 ? 0 : Number(Number(totalPrice) + Number(shippingPrice)).toFixed(2)} KM
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="checkoutPaymentContainer">
                    <label>
                      <input
                        type="radio"
                        name="payment"
                        value="Cash on delivery"
                        onChange={handlePaymentChange}
                      />
                      <div className="checkoutPaymentMethod">
                        <span>Plaćanje pouzećem</span>
                      </div>
                    </label>
                    <label className="karticnoMajku">
                      <input
                        type="radio"
                        name="payment"
                        value="Card"
                        onChange={handlePaymentChange}
                      />
                      <div className="checkoutPaymentMethod">
                        <span>Kartično plaćanje</span>
                        <div className="paymentIconContainer selectP">
                          <img onClick={() => {
                            window.open("http://monri.com/", "_blank", "noopener,noreferrer");
                          }} src="imgs/CardLogos/monri.png" alt="Monri" />
                          <img onClick={() => {
                            window.open("https://www.visa.com", "_blank", "noopener,noreferrer");
                          }} src="imgs/CardLogos/visa.jpg" alt="Visa" />
                          <img onClick={() => {
                            window.open("https://www.mastercard.com", "_blank", "noopener,noreferrer");
                          }} src="imgs/CardLogos/mastercard.png" alt="Mastercard®" />
                          <img onClick={() => {
                            window.open("https://brand.mastercard.com/brandcenter/more-about-our-brands.html", "_blank", "noopener,noreferrer");
                          }} src="imgs/CardLogos/maestro.png" alt="Maestro®" />
                          <img onClick={() => {
                            window.open("https://www.mastercard.com", "_blank", "noopener,noreferrer");
                          }} src="imgs/CardLogos/mastercardIDcheck.png" alt="Mastercard®" />
                          <img onClick={() => {
                            window.open("https://www.visa.com", "_blank", "noopener,noreferrer");
                          }} src="imgs/CardLogos/visasecure.jpg" alt="Visa" />
                        </div>
                      </div>
                    </label>
                    <div className="policyText">
                      <br />
                      Vaši podaci biti će korišteni za obradu ove narudžbe u skladu sa našom {" "}
                      <Link to="/terms" onClick={scrollToTop}>
                        Politikom privatnosti
                      </Link>
                      .
                    </div>
                  </div>
                  <button
                    onClick={() => {
                      createOrder();
                    }}
                  >
                    IZVRŠI NARUDŽBU
                  </button>
                  {error && <p style={{ color: 'red' }}>{error}</p>}
                </div>
              </div>
            )}

            {/* tab3 */}
            {activeTab === "cartTab3" && (
              <div className="orderCompleteSection">
                <div className="orderComplete">
                  <div className="orderCompleteMessage">
                    <div className="orderCompleteMessageImg">
                      <img src={success} alt="" />
                    </div>
                    {!error ? <h3>Narudžba je uspješna</h3> : <h3>Greška...</h3>}
                    {message && <p>{message}</p>}
                  </div>
                  <div className="orderInfo">
                    <div className="orderInfoItem">
                      <p>Broj narudžbe</p>
                      <h4>{orderID}</h4>
                    </div>
                    <div className="orderInfoItem">
                      <p>Datum</p>
                      <h4>{formatDate(currentDate)}</h4>
                    </div>
                    <div className="orderInfoItem">
                      <p>Ukupno</p>
                      <h4>{Number(Number(totalPrice) + Number(shippingPrice)).toFixed(2)} KM</h4>
                    </div>
                    <div className="orderInfoItem">
                      <p>Način plaćanja</p>
                      <h4>{selectedPayment == "Cash on delivery" ? 'Plaćanje pouzećem' : 'Kartično plaćeno'}</h4>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ShoppingCart;
